<template>
  <div v-if="item.child">
    <b-form-group :disabled="disabled">
      <label
        >Phí chuyển đổi:
        <span class="text-danger font-weight-bold"
          >({{ getInstallmentProgram.conversionFeePercent }}%)</span
        ></label
      >
      <b-form-input
        v-if="item.child.paymentAmount === 0"
        class="input-style text-right"
        v-model="item.child.paymentAmount"
        :disabled="true"
        :placeholder="conversionFeePlaceholder"
      ></b-form-input>
      <BInputNumber
        v-else
        v-model="item.child.paymentAmount"
        :disabled="true"
        :placeholder="conversionFeePlaceholder"
        v-b-tooltip.hover
        title="Đây là phí chuyển đổi"
      />
    </b-form-group>
    <b-form-group :disabled="disabled">
      <label>Hình thức thanh toán:</label>
      <b-form-select
        v-model="item.child.paymentOptionType"
        class="select-style"
        size="sm"
        value-field="id"
        text-field="name"
        :options="[
          {
            id: null,
            name: 'Chọn hình thức thanh toán',
          },
          {
            id: 'TM',
            name: 'Tiền mặt',
            disabled: !this.filteredCashAccOptions.length,
          },
          {
            id: 'CK',
            name: 'Chuyển khoản',
          },
          {
            id: 'QT',
            name: 'Quẹt thẻ',
          },
          {
            id: 'TG',
            name: 'Trả góp',
          },
        ]"
        @change="
          onChangeCheckBox({
            value: item.child.paymentOptionType,
          })
        "
      >
      </b-form-select>
    </b-form-group>
    <b-form-group :disabled="disabled">
      <label>Tài khoản thu phí chuyển đổi:</label>
      <Autosuggest
        placeholder="tài khoản chuyển khoản"
        :model="item.child.paymentName"
        :suggestions="filteredOptions"
        @change="onInputChange($event, item.child.paymentOptionType)"
        @select="onSelectedMul($event)"
      />
    </b-form-group>
    <b-form-group :disabled="disabled" class="my-2">
      <b-form-input
        class="input-style"
        size="sm"
        autocomplete="off"
        v-model="item.child.paymentCode"
        placeholder="Mã tham chiếu"
      ></b-form-input>
    </b-form-group>
  </div>
</template>

<script>
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import BInputNumber from '@/view/base/bootstrap/BInputNumber.vue';
import { mapGetters } from 'vuex';
import { removeAccents, convertPrice, unMaskPrice } from '@/utils/common';
import { CONVERTION_FEE_METHOD } from '@/utils/enum';

export default {
  props: {
    isDebt: {
      type: Boolean,
      default: false,
    },
    finalAmount: {
      type: Number,
    },
    item: {
      type: Object,
    },
    disabled: {
      type: Boolean,
    },
    filteredCashAccOptions: {
      type: Array,
    },
    filteredTransferAccOptions: {
      type: Array,
    },
    filteredCreditAccOptions: {
      type: Array,
    },
    filteredOptionsInstallment: {
      type: Array,
    },
    cashAccOptions: {
      type: Array,
    },
    transferOptions: {
      type: Array,
    },

    interestZeroExchange: {
      type: Number,
    },
    interestZeroLoan: {
      type: Number,
    },
  },
  data() {
    return {
      CONVERTION_FEE_METHOD,
      filteredOptions: [],
      optionsPaymentType: [],
      defaultValue: {
        id: this.$uuid.v4(),
        paymentRefId: null,
        paymentRefCode: null,
        paymentName: null,
        paymentAmount: null,
        paymentCode: null,
        transactionId: null,
        paymentOptionType: null,
      },
      conversionFeePlaceholder: 'Phí chuyển đổi',
    };
  },
  components: {
    Autosuggest,
    BInputNumber,
  },
  created() {},
  watch: {
    interestZeroLoan: {
      handler: function (newValue) {
        if (this.item && !this.item.child && this.isDebt) {
          this.item.child = this.defaultValue;
        }
        if (this.item && this.item.child && this.finalAmount && !this.isDebt) {
          const prepayAmount = +unMaskPrice(newValue);
          const baseAmount =
            prepayAmount === 0 ? this.finalAmount : prepayAmount;
          const calculatedAmount =
            (baseAmount * this.getInstallmentProgram.conversionFeePercent) /
            100;
          this.item.child.paymentAmount = Math.ceil(calculatedAmount);
        }
      },
      immediate: true,
    },
    'getInstallmentProgram.conversionFeePercent': {
      handler: function (newValue) {
        if (!this.item.child || this.isDebt) {
          this.item.child = this.defaultValue;
        }
        if (this.item && this.item.child && this.finalAmount && !this.isDebt) {
          const prepayAmount = +unMaskPrice(this.interestZeroLoan) || 0;
          const baseAmount =
            prepayAmount === 0 ? this.finalAmount : prepayAmount;
          const calculatedAmount = (baseAmount * newValue) / 100;
          this.item.child.paymentAmount = Math.ceil(calculatedAmount);
        }
      },
    },
  },
  computed: {
    ...mapGetters(['getInstallmentProgram', 'getInstallmentInterestZero']),
  },

  mounted() {},

  methods: {
    onChangeCheckBox(option) {
      this.item.child.paymentRefId = null;
      this.item.child.paymentRefCode = null;
      this.item.child.paymentName = null;
      this.item.child.paymentCode = null;
      if (option.value === 'TM') {
        this.filteredOptions = this.filteredCashAccOptions;
      } else if (option.value === 'CK') {
        this.filteredOptions = this.filteredTransferAccOptions;
      } else if (option.value === 'QT') {
        this.filteredOptions = this.filteredCreditAccOptions;
      } else if (option.value === 'TG') {
        this.filteredOptions = this.filteredOptionsInstallment;
      } else {
        this.filteredOptions = [];
      }
    },
    isTextNul(text) {
      if (!text || !text.length) {
        return true;
      }
      return false;
    },
    onSelectedMul(option) {
      if (!option) {
        return;
      }
      this.item.child.paymentRefId = option.item.id;
      this.item.child.paymentRefCode = option.item.code;
      this.item.child.paymentName = option.item.name;
    },
    onInputChange(text, type) {
      switch (type) {
        case 'TM': {
          this.filteredOptions = this.onFilterOptions(
            this.cashAccOptions,
            text,
          );
          break;
        }
        case 'CK': {
          this.filteredOptions = this.onFilterOptions(
            this.transferOptions,
            text,
          );
          break;
        }
      }
      if (this.isTextNul(text)) {
        this.item.child.paymentRefId = null;
        this.item.child.paymentRefCode = null;
        this.item.child.paymentName = null;
        return;
      }
    },
    onFilterOptions(options, text) {
      const filteredData = options[0].data
        .filter((item) => {
          return (
            removeAccents(item.name)
              .toLowerCase()
              .indexOf(removeAccents(text.toLowerCase())) > -1
          );
        })
        .slice(0, this.limit);
      return filteredData;
    },
    formatMoney(value) {
      return convertPrice(value);
    },
  },
};
</script>
